// extracted by mini-css-extract-plugin
module.exports = {"logoPlaceholder":"style__logoPlaceholder__rhuQd","header":"style__header__q4H0Z"};